export default __webpack_public_path__ + "static/media/p01.31b2bed7.jpg";